import { features } from '@/mocks/siteData';

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              为什么选择开云体育
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              六大核心优势，为您打造极致体育竞技体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${feature.icon} text-xl w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="font-semibold text-foreground-900 mb-2 text-base">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}